import {
  base_colorContentBorder,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_4xl,
  font_size_lg,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(8)};

  .BrandRedirectPopup-title {
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    font-size: ${font_size_4xl};
    line-height: 36px;
  }

  .BrandRedirectPopup-body {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_regular};
    font-size: ${font_size_lg};
    line-height: 20px;
  }

  .BrandRedirectPopup-suggestionList {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
    margin: 0 ${spacing(10)};

    li {
      list-style: none;

      .BrandRedirectPopup-suggestionList-link {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${base_colorContentBorder};
        border-radius: ${spacing(2)};
        padding: ${spacing(3)};
        height: 120px;
        transform-origin: center;

        // Specific edits to scale logos for different brands
        &.extend > * {
          transform: scale(2);
        }

        &.bmo > * {
          transform: scale(1.5);
        }

        &.boc > * {
          transform: scale(0.7);
        }

        &.jpm > * {
          transform: scale(3);
          padding-top: ${spacing(1)};
        }

        &.corpay > * {
          padding-top: ${spacing(2)};
        }
      }
    }
  }
`
